import { render, staticRenderFns } from "./ProductionView.vue?vue&type=template&id=535b1761&scoped=true"
import script from "./ProductionView.vue?vue&type=script&lang=js"
export * from "./ProductionView.vue?vue&type=script&lang=js"
import style0 from "./ProductionView.vue?vue&type=style&index=0&id=535b1761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b1761",
  null
  
)

export default component.exports